import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import promotionService from '../../services/promotionService';

// Async thunks
export const getPromotions = createAsyncThunk(
  'promotions/getPromotions',
  async (params = {}) => {
    const response = await promotionService.getPromotions(params);
    return response.data;
  }
);

export const createPromotion = createAsyncThunk(
  'promotions/createPromotion',
  async (promotionData) => {
    console.log('Redux Action: createPromotion called with:', promotionData);
    try {
      const response = await promotionService.createPromotion(promotionData);
      console.log('Redux Action: createPromotion response:', response);
      console.log('Redux Action: createPromotion response.data:', response.data);
      return response.data;
    } catch (error) {
      console.error('Redux Action: createPromotion error:', error);
      throw error;
    }
  }
);

export const updatePromotion = createAsyncThunk(
  'promotions/updatePromotion',
  async ({ id, promotionData }) => {
    console.log('Redux Action: updatePromotion called with:', { id, promotionData });
    const response = await promotionService.updatePromotion(id, promotionData);
    console.log('Redux Action: updatePromotion response:', response);
    console.log('Redux Action: updatePromotion response.data:', response.data);
    return response.data;
  }
);

export const deletePromotion = createAsyncThunk(
  'promotions/deletePromotion',
  async (id) => {
    await promotionService.deletePromotion(id);
    return id;
  }
);

const initialState = {
  promotions: [],
  currentPromotion: null,
  isLoading: false,
  error: null,
  success: false,
};

const promotionSlice = createSlice({
  name: 'promotions',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentPromotion: (state) => {
      state.currentPromotion = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get promotions
      .addCase(getPromotions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPromotions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.promotions = action.payload.promotions || action.payload;
        state.error = null;
      })
      .addCase(getPromotions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // Create promotion
      .addCase(createPromotion.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createPromotion.fulfilled, (state, action) => {
        console.log('Redux: createPromotion.fulfilled - Full payload:', action.payload);
        state.isLoading = false;
        const newPromotion = action.payload.promotion || action.payload;
        console.log('Redux: Adding new promotion:', newPromotion);
        state.promotions.push(newPromotion);
        state.error = null;
        state.success = true;
      })
      .addCase(createPromotion.rejected, (state, action) => {
        console.error('Redux: createPromotion.rejected - Error:', action.error);
        state.isLoading = false;
        state.error = action.error.message || 'Failed to create promotion';
        state.success = false;
      })
      // Update promotion
      .addCase(updatePromotion.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePromotion.fulfilled, (state, action) => {
        console.log('Redux: updatePromotion.fulfilled - Full payload:', action.payload);
        state.isLoading = false;
        const updatedPromotion = action.payload.promotion || action.payload;
        console.log('Redux: updatedPromotion:', updatedPromotion);
        console.log('Redux: updatedPromotion._id:', updatedPromotion._id);
        console.log('Redux: current promotions:', state.promotions.map(p => ({ _id: p._id, title: p.title })));
        
        const index = state.promotions.findIndex(
          (promotion) => promotion._id === updatedPromotion._id
        );
        console.log('Redux: found index:', index);
        if (index !== -1) {
          console.log('Redux: before update - promotion at index:', state.promotions[index]);
          state.promotions[index] = updatedPromotion;
          console.log('Redux: after update - promotion at index:', state.promotions[index]);
          console.log('Redux: updated promotion in state');
        } else {
          console.log('Redux: ERROR - promotion not found in state!');
        }
        state.error = null;
        state.success = true;
      })
      .addCase(updatePromotion.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // Delete promotion
      .addCase(deletePromotion.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deletePromotion.fulfilled, (state, action) => {
        state.isLoading = false;
        state.promotions = state.promotions.filter(
          (promotion) => promotion._id !== action.payload
        );
        state.error = null;
        state.success = true;
      })
      .addCase(deletePromotion.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearError, clearCurrentPromotion, clearSuccess } = promotionSlice.actions;
export default promotionSlice.reducer;
